import { render } from "./error-page.view.vue?vue&type=template&id=06605225&ts=true"
import script from "./error-page.view.vue?vue&type=script&lang=ts"
export * from "./error-page.view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__